<template >
  <div class="text-center menu">
        
<!--       
  <div class="image-background">
    <img :src="require('@/assets/fondo-background.png')" alt="">
  </div> 
-->
   
   <!--  <div class="idioma black-text">
      <switch-language />
    </div> -->

    <menu-principal/>


<!--       
  <v-menu
      transition="slide-y-transition"
      bottom
      color="white"
      open-on-hover offset-y
      v-for="(menu, index) in menu"
        :name="menu.name"
        :key="'menu'+index"
    >
    <template v-slot:activator="{ on }">

        <v-btn v-if="menu.children" 
          color="white"
          v-on="on"
          class="menu-principal--with-children "
          text
        >
        <v-icon size="15" class="icon-submenu" :color="menu.color"> {{ menu.icon }}</v-icon>              
            {{ menu.name }}
          <icon-base v-if="menu.children" icon-name="arrowDown" height="18" width="18"><arrowDown /></icon-base>
        </v-btn>

        <v-btn v-else
          :to="menu.path"
          class="menu-principal"
          color="white"
          text
        >
          <v-icon size="15" class="icon-submenu" :color="menu.color"> {{ menu.icon }}</v-icon>
          {{ menu.name }}
        </v-btn>
    </template>

  <submenu-item :menu="menu"  /> 
  
</v-menu>  -->
  </div>
</template>
<script>

// import SwitchLanguage from '@/components/SwitchLanguage.vue'
import MenuPrincipal from '../menu/MenuPrincipal.vue'

export default {
  name: 'MenuBase',
  components: {

    /* SwitchLanguage, */
    MenuPrincipal
  },
  
  props: [
  ],
  methods: {
    triggerClick: function (route){
      this.$router.push(route);
    }
  },
  computed: {
    rutas () {
      return this.$router.options.routes;
    },
    menu () {
      return this.$store.state.menu
    }
  }
};
</script>

<style scoped lang="scss">

  .icon-submenu {
    margin-right: 5px !important;
    padding-right: 0 !important;
    width: 20px !important;
    font-size: 20px !important;
  }

  .image-background {
    position: absolute;
    left:0;
    top: 10px;
  }

</style>